import type { PropsWithChildren } from "react";
import styles from "../RichTextBlok.module.css";

export const ListItem = ({ children }: PropsWithChildren) => {
	if (!children) return null;
	return <li className={styles.listItem}>{children}</li>;
};
